<template>
  <Sidebar />
  <Content class="creator-content" :hide_alert="true">
    <div class="inner" :class="{'no-padding': !is_show_list}">
      <Scrollbar class="right" style="padding: 0;" :show_bar="true" v-if="!is_show_list">
        <header class="add-heading">
          <h2>Creator Management</h2>
        </header>

        <AddPartner @add-creator="addCreator" @no-data="is_show_list = true" :is-inline="true" />
      </Scrollbar>
      <Scrollbar class="right" :show_bar="true" @scroll="scroll" v-else>
        <header class="heading" ref="heading">
          <div class="top">
            <h2>Review Creators</h2>
            <p>Confirm creator details are accurate before adding. Duplicate creators with a matching email or social handle will not be imported.</p>
            <div class="btns" v-if="!is_show_enabling">
              <i class="close" @click="is_show_quit_modal = true"><SvgIcon name="close" /></i>
            </div>
          </div>

          <div class="text-wrap">
            <div class="text" v-if="!is_show_enabling && total_row_count !== 0">
              {{ total_row_count }} total row(s). <br />
              {{ new_creator_count }} new creator(s). <br />
              <span v-if="exist_creator_count !== 0">{{ exist_creator_count }} existing.<br /></span>
              <span class="error-msg" v-if="errorCount !== 0"> {{ errorCount }} errors to resolve. </span>
            </div>
            <Usage
              v-if="!is_show_enabling"
              :only_creator="true"
              :is_use_props="true"
              :current_creator_count="current_creator_count + $store.state.current_creator_count"
            />
            <p
              class="warning"
              v-if="
                $store.state.user_data.merchant_account &&
                !$store.state.is_loading &&
                current_creator_count >= $store.state.creator_max_count
              "
            >
              Creator limit reached.
              <!-- <router-link :to="'/help'"> Contact us to upgrade.</router-link> -->
              <a v-if="$store.state.projectName !== 'cj'" :href="`mailto:${$store.state.mail_to_creator}?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Upgrade creator limit&body=Please provide your name and contact info. A representative will contact you in 1-2 business days.`" target="_blank">Contact us to upgrade.</a>
              <a v-else href="#" @click.prevent="EventBus.emit('open-global-drawer', 'help-support')">Contact us to upgrade.</a>
            </p>
          </div>

          <div class="selected-info" v-if="!is_show_enabling">
            <strong>New Creators ({{ data.filter((o) => o.is_selected === true).length }} selected)</strong>
            <div class="btns" :class="{ disabled: data.filter((o) => o.is_selected === true).length === 0 }">
              <Button type="button" color="no-color" size="32" @click.native="removeSelects">Delete</Button>
              <Button
                class="add-more-btn"
                type="button"
                :style="'border'"
                color="black-60"
                size="32"
                @click.native="is_show_add_modal = true"
                :is_disabled="
                  current_creator_count + $store.state.current_creator_count >= $store.state.creator_max_count
                "
              >
                <SvgIcon name="add-user" />Add more
              </Button>
              <Button
                type="button"
                color="dark-blue"
                size="32"
                @click.native="enableAll(1)"
                :is_disabled="getNonErrorSelectedCount() === 0 || $store.state.current_creator_count >= $store.state.creator_max_count"
                >Enable</Button
              >
            </div>
          </div>

          <div class="progress-rate" v-if="is_show_enabling">
            <div class="bar">
              <div class="bg" :style="{ width: progress + '%' }"></div>
              <h4>Enabling Anchor storefronts</h4>
              <p>{{ selectedCount }} creators active</p>
            </div>
          </div>
        </header>
        <div class="data-wrap">
          <NoData
            v-if="
              (!is_show_enabling && data.length === 0 && exist_creators.length === 0) ||
              (is_show_enabling && todo_list.length === 0)
            "
          />
          <div class="data-list" v-else>
            <Table :style="top" v-if="is_show_enabling && !is_loading">
              <template #head>
                <tr>
                  <th v-for="(column, index) in enable_columns" :key="index">
                    <span v-if="column.label" v-html="column.label"></span>
                    <i v-if="column.sortable"></i>
                  </th>
                </tr>
              </template>
              <template #body>
                <tr v-for="(row, index) in todo_list" :key="index" :class="[{ selected: row.is_selected }]">
                  <td v-html="row.first_name + ' ' + row.last_name"></td>
                  <td>
                    <a v-if="row.email" :href="`mailto:${row.email}`" target="_blank">{{ row.email }}</a>
                    <span v-else>---</span>
                  </td>
                  <td>
                    <a v-if="row.tiktok_handle" href="https://www.tiktok.com/" target="_blank">{{
                      row.tiktok_handle
                    }}</a>
                  </td>
                  <td>
                    <a v-if="row.instagram_handle" href="https://instagram.com" target="_blank"
                      >@{{ row.instagram_handle }}</a
                    >
                  </td>
                  <td v-if="$ProjectName !== 'sephora'">
                    <div class="profile" :class="['class-' + row.status]">
                      <img src="@/assets/images/user.png" />
                      <span class="error-item" v-if="row.status === -4">Account Type Error</span>
                      <span v-else-if="row.status === -10 && row.motom_user_id !== '' && row.motom_user_unique_key !== ''"
                        >Joined</span
                      >
                      <span
                        class="error-item"
                        v-else-if="
                          row.status === -10 && row.motom_user_id === null && row.motom_user_unique_key === null && $store.state.projectName === 'cj' && !row.email
                        "
                        >Account Type Error</span
                      >
                      <span
                        v-else-if="
                          row.status === -10 && row.motom_user_id === null && row.motom_user_unique_key === null
                        "
                        >Pending</span
                      >
                      <span v-else>{{ row.status_text }}</span>
                    </div>
                  </td>
                  <td class="account-type-td">
                    <span>{{ row.platform_type === 'storefront' ? 'Storefront' : 'Links' }}</span>
                  </td>
                  <td>
                    <SvgIcon v-if="row.is_active" name="yes" />
                    <SvgIcon v-else name="waiting" />
                  </td>
                </tr>
              </template>
            </Table>

            <Table :style="top" v-else-if="!is_loading" :key="table_key">
              <template #head>
                <tr>
                  <th @click="selectAll(data)">
                    <Checkbox :checked="data.filter((o) => o.is_selected === true).length === data.length" />
                  </th>
                  <th v-for="(column, index) in columns" :key="index">
                    <span v-if="column.label" v-html="column.label"></span>
                    <i v-if="column.sortable"></i>
                  </th>
                </tr>
              </template>
              <template #body>
                <tr
                  v-for="(row, index) in data"
                  :key="index"
                  :class="['row-item', { selected: row.is_selected }, { error: handleDis(row) }]"
                >
                  <td @click="checkBox(row)">
                    <Checkbox :checked="row.is_selected" />
                  </td>
                  <td
                    class="name"
                    v-if="row.first_name && row.last_name"
                    v-html="`${row.first_name} ${row.last_name}`"
                  ></td>
                  <td class="name-miss" v-else><span class="error-item">Missing name</span><br /></td>
                  <td class="email-td">
                    <span
                      class="error-item"
                      v-if="row.tiktok_handle === '' && row.instagram_handle === '' && row.email === ''"
                      >Missing social info</span
                    >
                    <span
                      class="error-item"
                      v-else-if="row.email && !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/.test(row.email)"
                      >Formatting error</span
                    >
                    <span class="error-item" v-else-if="checkSame(row.email, 'email', row.id)">Duplicate email</span>
                    <a
                      v-else-if="row.email"
                      v-tippy="{ content: row.email, delay: [500, 20] }"
                      :href="`mailto:${row.email}`"
                      target="_blank"
                      >{{ row.email }}</a
                    >
                    <span v-else>---</span>
                  </td>
                  <td>
                    <span
                      class="error-item"
                      v-if="row.tiktok_handle === '' && row.instagram_handle === '' && row.email === ''"
                      >Missing social info</span
                    >
                    <span
                      class="error-item"
                      v-else-if="row.tiktok_handle !== '' && !/(^$)|^@?[a-zA-Z0-9_.]+$/.test(row.tiktok_handle)"
                      >Formatting error</span
                    >
                    <span class="error-item" v-else-if="checkSame(row.tiktok_handle, 'tiktok_handle', row.id)"
                      >Duplicate social info</span
                    >
                    <a v-else-if="row.tiktok_handle" href="https://www.tiktok.com/" target="_blank">{{
                      row.tiktok_handle
                    }}</a>
                    <span v-else>---</span>
                  </td>
                  <td>
                    <span
                      class="error-item"
                      v-if="row.tiktok_handle === '' && row.instagram_handle === '' && row.email === ''"
                      >Missing social info</span
                    >
                    <span
                      class="error-item"
                      v-else-if="row.instagram_handle !== '' && !/(^$)|^[aA-zZ0-9_.]+$/.test(row.instagram_handle)"
                      >Formatting error</span
                    >
                    <span class="error-item" v-else-if="checkSame(row.instagram_handle, 'instagram_handle', row.id)"
                      >Duplicate social info</span
                    >
                    <a v-else-if="row.instagram_handle" href="https://instagram.com" target="_blank"
                      >@{{ row.instagram_handle }}</a
                    >
                    <span v-else>---</span>
                  </td>
                  <td v-if="$ProjectName !== 'sephora'">
                    <div class="profile" :class="['class-' + row.status]">
                      <img src="@/assets/images/user.png" />
                      <span class="error-item" v-if="row.status === -4">Account Type Error</span>
                      <span
                        v-else-if="row.status === -10 && row.motom_user_id !== null && row.motom_user_unique_key !== null"
                        >Joined</span
                      >
                      <span
                        class="error-item"
                        v-else-if="
                          row.status === -10 && row.motom_user_id === null && row.motom_user_unique_key === null && $store.state.projectName === 'cj' && !row.email
                        "
                        >Account Type Error</span
                      >
                      <span
                        v-else-if="
                          row.status === -10 && row.motom_user_id === null && row.motom_user_unique_key === null
                        "
                        >Pending</span
                      >
                      <span v-else>{{ row.status_text === 'Not Enable' ? 'Not Enabled' : row.status_text }}</span>
                    </div>
                  </td>
                  <td v-if="is_link_only">
                    <span>Links</span>
                  </td>
                  <td class="account-type-td" v-else>
                    <ElSelect
                      v-model="row.platform_type"
                      class="account-type-inline-select"
                      size="small"
                      :teleported="true"
                      :disabled="is_link_only"
                      popper-class="account-type-popper"
                    >
                      <ElOption label="Storefront" value="storefront" />
                      <ElOption label="Links" value="linkonly" />
                    </ElSelect>
                  </td>

                  <!-- tags @mouseover="$store.state.merchant_disabeld ? none : row.hover_tag_list_box=true" @mouseleave="row.hover_tag_list_box = false"(not do at this time)-->
                  <td class="tags-list-box-td">
                    <span
                      :class="[
                        'tags-list-box',
                        (row.hover_tag_list_box || row.last_tag_open || row.last_tag_all_open) && 'edit-tags-list-box',
                      ]"
                    >
                      <div
                        @click.stop="
                          openCreTag(index, 'tag');
                          row.last_tag_all_open = false;
                        "
                        class="add-tag-btn"
                        v-show="
                          row.edit_tag_list_box ||
                          (row.hover_tag_list_box && permission_creator?.addOrEditCreatorTags.permission)
                        "
                      >
                        <svg-icon name="tag-plus" />
                      </div>
                      <Badage
                        :class="['tag-item-box', styleTagLong(row, v, k)]"
                        v-for="(v, k) in row.merchant_account_tags.filter((ee, kk) => {
                          return kk < 1;
                        })"
                        :key="k"
                        :value="v.tag"
                        :show_tippy="true"
                      >
                        <!-- (not do at this time) -->
                        <!-- <svg-icon v-if="permission_creator?.addOrEditCreatorTags.permission"  :class="{'ths-show': ( row.hover_tag_list_box || row.last_tag_open || row.last_tag_all_open) }" name="close" @click.stop="handleSelectTag({tag:v, row:row },'from_outside')"/> -->
                      </Badage>
                      <Badage
                        @click.stop="
                          openCreTag(index, 'tag_all');
                          row.last_tag_open = false;
                        "
                        v-if="row.merchant_account_tags.length - 1 > 0"
                        :value="`+${row.merchant_account_tags.length - 1}`"
                      ></Badage>
                    </span>
                    <!-- close:last_tag_open -->
                    <DropdownHashtag
                      class="tag_cre_drop-last"
                      :tags="row.tags"
                      :selected_tags="row.merchant_account_tags"
                      :tag_type="'creator_tag'"
                      @select-tag="selectTag"
                      @closeKey="
                        row.last_tag_open = false;
                        open_cre_tag_drop = false;
                      "
                      :outside_remove="true"
                      :open_key="row.last_tag_open"
                      :row="row"
                      :drop_css="'right:200px'"
                      :index="index"
                      :key="is_loading"
                    />
                    <!-- open:last_tag_all_open -->
                    <HashtagPopup
                      :tags="row.merchant_account_tags"
                      :row="row"
                      :open_key="row.last_tag_all_open"
                      :drop_css="'right:200px'"
                      :index="index"
                      @closeKey="row.last_tag_all_open = false"
                      @open-cre-tag="
                        openCreTag(index, 'tag');
                        row.last_tag_all_open = false;
                      "
                      :key="is_loading"
                      :can_edit="false"
                    />
                  </td>

                  <td>
                    <div class="btns">
                      <span class="js-edit-btn btn edit" @click.stop="edit(row)"
                        ><svg><use xlink:href="#pen--sprite"></use></svg></span>
                      <span class="js-remove-btn btn remove" @click.stop="remove(1, data, row)"
                        ><svg><use xlink:href="#remove--sprite"></use></svg></span>
                    </div>
                  </td>
                </tr>
                <tr
                  v-for="(row, index) in exist_creators"
                  :key="index"
                  :class="[{ selected: row.is_selected }, 'error']"
                >
                  <td><Checkbox :disabled="true" /></td>
                  <td v-html="row.first_name + ' ' + row.last_name"></td>
                  <td>
                    <a v-if="row.email" :href="`mailto:${row.email}`" target="_blank">{{ row.email }}</a>
                    <span
                      class="error-item"
                      v-else-if="row.email === '' && row.tiktok_handle === '' && row.instagram_handle === ''"
                      >error, please fix</span
                    >
                    <span v-else>---</span>
                  </td>
                  <td>
                    <a v-if="row.tiktok_handle" href="https://www.tiktok.com/" target="_blank">{{
                      row.tiktok_handle
                    }}</a>
                    <span
                      class="error-item"
                      v-else-if="row.tiktok_handle === '' && row.instagram_handle === '' && row.email === ''"
                      >error, please fix</span
                    >
                    <span v-else>---</span>
                  </td>
                  <td>
                    <a v-if="row.instagram_handle" href="https://instagram.com" target="_blank"
                      >@{{ row.instagram_handle }}</a
                    >
                    <span
                      class="error-item"
                      v-else-if="row.tiktok_handle === '' && row.instagram_handle === '' && row.email === ''"
                      >error, please fix</span
                    >
                    <span v-else>---</span>
                  </td>
                  <td v-if="$ProjectName !== 'sephora'">
                    <div class="profile" :class="['class-' + row.status]">
                      <!-- <span>Already Imported</span> -->
                      <img src="@/assets/images/user.png" />
                      <span>Imported</span>
                    </div>
                  </td>
                  <td class="account-type-td">
                    <span>---</span>
                  </td>
                  <td></td>
                  <td>
                    <div class="btns">
                      <span class="js-remove-btn btn remove" @click.stop="removeExistCreators(row)"><svg><use xlink:href="#remove--sprite"></use></svg></span>
                    </div>
                  </td>
                </tr>
              </template>
            </Table>
          </div>
        </div>
      </Scrollbar>
    </div>
  </Content>

  <el-dialog v-model="is_show_quit_modal" class="alert-modal" :show-close="false" width="330">
    <div class="box">
      <header class="delete-header">These creators are not uploaded yet</header>
      <p>Please click "Enable" to confirm your upload.</p>
      <div class="btns">
        <Button type="button" color="no-color" size="32" @click.native="quitAnyway()">Quit anyways</Button>
        <Button type="button" color="dark-blue" size="32" @click.native="quit()">Go back</Button>
      </div>
    </div>
  </el-dialog>

  <!-- No longer in use. -->
  <el-dialog v-model="is_show_error_modal" class="alert-modal" :show-close="false" width="330">
    <div class="box">
      <header class="delete-header">Enable storefront?</header>
      <p>
        {{ updateCount }} selected creator ready to enable storefront, we are exclusive
        {{
          data.filter(
            (p) => p.is_selected && (!p.first_name || !p.last_name || (!p.instagram_handle && !p.tiktok_handle))
          ).length
        }}
        error selection
      </p>
      <div class="btns">
        <Button type="button" color="no-color" size="32" @click.native="is_show_error_modal = false">No</Button>
        <Button type="button" color="dark-blue" size="32" @click.native="enableAll(2)">Yes</Button>
      </div>
    </div>
  </el-dialog>

  <el-dialog v-model="is_show_delete_modal" class="alert-modal" :show-close="false" width="330">
    <div class="box" v-if="delete_row.length === data.length">
      <header class="delete-header">
        Remove {{ typeof delete_row === 'object' && !Array.isArray(delete_row) ? 1 : delete_row.length }} creator{{
          (typeof delete_row === 'object' && !Array.isArray(delete_row)) || delete_row.length === 1 ? '' : 's'
        }}?
      </header>
      <p>This includes all the creators in your data upload.</p>
      <div class="btns">
        <Button type="button" color="no-color" size="32" @click.native="remove(3)">No</Button>
        <Button type="button" color="dark-blue" size="32" @click.native="remove(2)">Yes</Button>
      </div>
    </div>
    <div class="box" v-else>
      <header class="delete-header">Delete selection?</header>
      <p>
        This will remove
        {{ typeof delete_row === 'object' && !Array.isArray(delete_row) ? 1 : delete_row.length }} creator(s) from your
        list.
      </p>
      <div class="btns">
        <Button type="button" color="no-color" size="32" @click.native="remove(3)">No</Button>
        <Button type="button" color="dark-blue" size="32" @click.native="remove(2)">Yes</Button>
      </div>
    </div>
  </el-dialog>

  <el-dialog v-model="is_show_add_modal" class="add-creator-modal" :show-close="false" width="650">
    <i class="close-add-creator-modal" @click="is_show_add_modal = false"><svg-icon name="close" /></i>
    <AddPartner @add-creator="addCreator" @no-data="is_show_list = true" />
  </el-dialog>

  <EditCreator ref="edit" @delete="deleteRow" @save="saveEdit" />

  <!-- for tag -->
  <el-dialog
    :model-value="$store.state.spec_value.open_tag_remove_outside_modal"
    @close="$store.state.spec_value.open_tag_remove_outside_modal = false"
    class="alert-modal"
    :show-close="false"
    width="330"
     >
    <div class="box remove-box">
      <header class="delete-header">{{ remove_text.title }}</header>
      <p>{{ remove_text.content }}</p>

      <div class="btns">
        <Button
          type="button"
          color="no-color"
          size="32"
          @click.stop="$store.state.spec_value.open_tag_remove_outside_modal = false"
          >No</Button
        >
        <Button
          type="button"
          color="dark-blue"
          size="32"
          @click.stop="
            $store.state.spec_value.open_tag_remove_outside_modal = false;
            $store.state.spec_value.confirm_remove_outside_modal = true;
          "
          >Yes, confirm</Button
        >
      </div>
    </div>
  </el-dialog>

  <el-dialog
    :model-value="$store.state.spec_value.open_tag_edit_outside_modal"
    @close="$store.state.spec_value.open_tag_edit_outside_modal = false"
    class="alert-modal"
    :show-close="false"
    width="330"
     >
    <div class="box remove-box">
      <header class="delete-header">Update this tag?</header>
      <p>{{ `Updates will be made on ${$store.state.spec_value.del_tag_num} creators.` }}</p>

      <div class="btns">
        <Button
          type="button"
          color="no-color"
          size="32"
          @click.stop="$store.state.spec_value.open_tag_edit_outside_modal = false"
          >No</Button
        >
        <Button
          type="button"
          color="dark-blue"
          size="32"
          @click.stop="
            $store.state.spec_value.open_tag_edit_outside_modal = false;
            $store.state.spec_value.confirm_edit_outside_modal = true;
          "
          >Yes, confirm</Button
        >
      </div>
    </div>
  </el-dialog>

  <el-dialog v-model="tag_remove_modal" class="alert-modal" :show-close="false" width="330">
    <div class="box remove-box" v-if="$ProjectName === 'sephora' && handle_remove_tag_value.tag.text === 'elevated'">
      <header class="delete-header">Remove the tag linked to the creator's storefront template?</header>
      <p>
        You're about to remove the 'Elevated' tag, which is linked to a custom storefront template for the creator. Once
        removed, the creator's storefront will revert to the standard basic template, and some functionality from the
        current template will be limited.
      </p>
      <p>Are you sure you want to proceed?</p>
      <div class="btns">
        <Button type="button" color="no-color" size="32" @click.stop="tag_remove_modal = false">Cancel</Button>
        <Button
          type="button"
          color="dark-blue"
          size="32"
          @click.stop="
            tag_remove_modal = false;
            selectTag(handle_remove_tag_value, 'from_outside');
          "
          >Confirm</Button
        >
      </div>
    </div>
    <div class="box remove-box" v-else>
      <header class="delete-header">Remove tag</header>
      <p>Are you sure you want to remove the "{{ handle_remove_tag_value.tag.text }}" tag?</p>
      <div class="btns">
        <Button type="button" color="no-color" size="32" @click.stop="tag_remove_modal = false">No</Button>
        <Button
          type="button"
          color="dark-blue"
          size="32"
          @click.stop="
            tag_remove_modal = false;
            selectTag(handle_remove_tag_value, 'from_outside');
          "
          >Yes, confirm</Button
        >
      </div>
    </div>
  </el-dialog>

  <!-- <Modal :is_show="is_show_get_started" class="get-started-modal" @click-bg="closeGetStarted">
    <div class="box">
      <h2>Welcome to Anchor!</h2>
      <p>Own your creator commerce - everything you need to recruit and onboard creators, drive engagement, and measure performance at scale.</p>
      <Button type="button" color="dark-blue" size="40" :border_r="6" @click.native="closeGetStarted">Get started</Button>
    </div>
  </Modal> -->
</template>

<script>
import '@/assets/svg/pen.svg?sprite';
import '@/assets/svg/remove.svg?sprite';
import '@/assets/svg/question.svg?sprite';

import Sidebar from '@/components/Sidebar.vue';
import Button from '@/components/ui/Button.vue';
import Content from '@/components/ui/Content.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Table from '@/components/ui/Table.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import AddPartner from '@/components/creator/AddPartner.vue';
import EditCreator from '@/components/creator/EditCreator.vue';
import NoData from '@/components/creator/NoData.vue';
import Usage from '@/components/ui/Usage.vue';
import DropdownHashtag from '@/components/DropdownHashtag.vue';
import HashtagPopup from '@/components/HashtagPopup.vue';
import { getTags, handleCreTag, selectTag } from '@/utils/CreatorTagFun';
import Badage from '@/components/ui/Badage.vue';
import { ElSelect, ElOption, ElDialog, } from 'element-plus';

export default {
  name: 'Creator - Get started',

  data() {
    return {
      data: [],
      exist_creators: [],
      todo_list: [],
      progress: 0,
      columns: [],

      enable_columns: [],

      delete_row: false,
      // edit_row: {},
      delete_rows: [],
      error_count: 0,
      exist_creator_count: 0,
      new_creator_count: 0,
      total_row_count: 0,
      is_show_list: false,
      is_show_delete_modal: false,
      is_show_add_modal: false,
      is_show_error_modal: false,
      // is_show_add_another_modal: false,
      is_show_quit_modal: false,
      is_show_enabling: false,
      is_paused_enableing: false,
      // is_show_get_started: false,
      top: '--top: 0px',
      interval: null,
      timer: 0,
      current_creator_count: 0,
      timeout_timer: null,
      pick_data: 0,
      table_key: 0,
      open_cre_tag_drop: false,
      handle_remove_tag_value: {
        //抓住準備要unbind的tag和creator
        row: null,
        tag: '',
      },
      tag_remove_modal: false,
      programs_for_cre: [],
      is_loading: true,
      handle_remove_tag_value: {
        //抓住準備要unbind的tag和creator
        row: null,
        tag: '',
      },
    };
  },

  computed: {
    updateCount() {
      return this.data.filter((p) => p.is_selected && !this.handleDis(p)).length;
    },

    activeCount() {
      return this.todo_list.filter((item) => item.is_active === true).length;
    },
    selectedCount() {
      return this.todo_list.length;
    },
    errorCount() {
      return this.data.filter((o) => this.handleDis(o)).length;
    },
    permission_creator() {
      return this.$store.state.user_data?.permission_list?.creatorManagement;
    },
    remove_text() {
      return {
        title: `Remove tags?`,
        content: `The tag will be removed from ${this.$store.state.spec_value.del_tag_num} Creators.`,
      };
    },
    is_link_only() {
      return this.$store.state.user_data?.merchant_account?.platform_type === 'linkonly';
    },
  },

  components: {
    Sidebar,
    Button,
    Content,
    Scrollbar,
    SvgIcon,
    ElDialog,
    Table,
    Checkbox,
    AddPartner,
    EditCreator,
    NoData,
    Usage,
    DropdownHashtag,
    HashtagPopup,
    Badage,
    ElOption,
    ElSelect,
  },

  methods: {
    selectAll(rows) {
      if (rows.some((row) => row.is_selected)) {
        rows.forEach((row) => {
          row.is_selected = false;
        });
      } else {
        let nonErrorCount = 0;
        rows.forEach((row) => {
          if (this.handleDis(row)) {
            // error rows can be selected (for deletion only)
            row.is_selected = true;
          } else if (
            nonErrorCount + this.$store.state.current_creator_count <
            this.$store.state.creator_max_count
          ) {
            row.is_selected = true;
            nonErrorCount++;
          }
        });
      }

      this.current_creator_count = this.getNonErrorSelectedCount();

      if (this.current_creator_count >= this.$store.state.creator_max_count) {
        this.$notify({
          title: `
                    <svg><use xlink:href="#alert--sprite"></use></svg>
                    Creator limit reached. <a href="mailto:${this.$store.state.mail_to}" target="_blank">Contact us to upgrade</a>`,
          type: 'warning',
          duration: 5000,
        });
      }

      setTimeout(() => {
        this.scroll();
      }, 10);
    },

    checkBox(row) {
      const isError = this.handleDis(row);
      if (
        !isError &&
        this.current_creator_count + this.$store.state.current_creator_count >= this.$store.state.creator_max_count &&
        row.is_selected === false
      ) {
        this.$notify({
          title: `
                    <svg><use xlink:href="#alert--sprite"></use></svg>
                    Creator limit reached. <a href="mailto:${this.$store.state.mail_to}" target="_blank">Contact us to upgrade</a>`,
          type: 'warning',
          duration: 5000,
        });
      } else {
        row.is_selected = !row.is_selected;
        this.current_creator_count = this.getNonErrorSelectedCount();
      }
    },

    cancelAll(rows) {
      rows.forEach((row) => {
        row.is_selected = false;
      });

      setTimeout(() => {
        this.scroll();
      }, 10);
    },

    updateCreator(data) {
      data.new_creator_list.forEach((item) => {
        this.data.push(item);
      });

      this.handleData();
      data.exist_creator_list.forEach((item) => {
        this.total_row_count++;
        this.exist_creator_count++;
        this.exist_creators.unshift(item);
      });
    },

    addCreator(data) {
      this.updateCreator(data);
      this.is_show_list = true;
      this.is_show_add_modal = false;
      this.EventBus.emit('update-import-stage', 1);
    },

    edit(row) {
      this.$refs.edit.open(row, 1);
      this.edit_row = row;
    },

    // closeGetStarted() {
    //   this.is_show_get_started = false;
    //   window.localStorage.setItem('has_entered_get_started', 'true');
    // },

    removeExistCreators(row) {
      //this.exist_creator_count
      this.exist_creators = this.exist_creators.filter((item) => item.id !== row.id);
      this.exist_creator_count = this.exist_creators.length;
      this.total_row_count = this.data.length + this.exist_creators.length;
    },

    remove(type, rows, row) {
      switch (type) {
        case 1:
          this.is_show_delete_modal = true;
          this.delete_rows = rows;
          this.delete_row = row;
          break;

        case 2:
          this.is_show_delete_modal = false;
          const form_data = {};
          form_data.status = -1;
          form_data.anchor_creator_ids = [];

          if (Array.isArray(this.delete_row)) {
            this.delete_row.forEach((p) => {
              this.delete_rows.forEach((item, index, object) => {
                if (item.id === p.id) {
                  form_data.anchor_creator_ids.push(item.id);
                  object.splice(index, 1);
                }
              });
            });

            this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> Selected has been removed.');
          } else {
            this.delete_rows.forEach((item, index, object) => {
              if (item.id === this.delete_row.id) {
                form_data.anchor_creator_ids.push(item.id);
                object.splice(index, 1);
              }
            });

            this.$notify(
              '<svg><use xlink:href="#yes--sprite"></use></svg>' +
                this.delete_row.first_name +
                ' ' +
                this.delete_row.last_name +
                ' has been removed.'
            );
          }

          this.$ajax('/creator/update-creator-status', {
            method: 'post',
            data: form_data,
          }).then((res) => {
            this.$store.commit('check_limit', this);
          });

          this.delete_row = false;
          this.delete_rows = [];

          if (this.data.length === 0) {
            this.is_show_list = false;
            this.EventBus.emit('update-import-stage', 0);
          }

          this.total_row_count = this.data.length + this.exist_creators.length;
          this.new_creator_count = this.data.length;
          this.current_creator_count = this.getNonErrorSelectedCount();
          this.$refs.edit.close();
          break;

        case 3:
          this.is_show_delete_modal = false;
          this.delete_row = false;
          this.delete_rows = [];
          break;
      }

      setTimeout(() => {
        this.scroll();
      }, 10);
    },

    quit() {
      // this.is_show_list = false;
      // this.EventBus.emit('update-import-stage', 0);
      // this.data = [];
      this.is_show_quit_modal = false;
    },

    async quitAnyway() {
      this.is_show_quit_modal = false;
      await this.$store.commit('check_limit', this);
      if (this.$store.state.current_creator_count === 0) {
        window.location.replace('/creator/get-started');
      } else {
        this.$router.replace('/creator/list');
      }
    },

    deleteRow() {
      this.remove(1, this.data, this.edit_row);
    },

    removeSelects() {
      this.remove(1, this.data, JSON.parse(JSON.stringify(this.data.filter((item) => item.is_selected === true))));
    },

    addItems() {
      // this.is_show_add_another_modal = false;
      this.is_show_error_modal = false;

      for (let i = 0; i < this.data.length; i++) {
        const p = this.data[i];
        if (p.is_selected && !this.handleDis(p)) {
          this.todo_list.push(p);
        }
      }
      this.data = this.data.filter((o) => !o.is_selected || this.handleDis(o));
    },

    enableAll(step = 1) {
      this.pick_data = this.getNonErrorSelectedCount();
      if (step === 1 && this.getNonErrorSelectedCount() !== 0) {
        // this.is_show_add_another_modal = true;
        this.enableAll(3);
      }
      else if (step === 2) {
        this.addItems();
      } else if (step === 3) {
        this.addItems();
        this.EventBus.emit('update-import-stage', 2);
        this.is_show_enabling = true;
        // this.timer = this.selectedCount;
        this.enableing();
      }

      setTimeout(() => {
        this.scroll();
      }, 10);
    },

    share() {
      const obj = {};
      obj.url = 'test';
      this.EventBus.emit('open-share', obj);
    },

    frame() {
      if (this.progress >= 99) {
        window.clearInterval(this.timer);
      } else {
        this.progress++;
      }
    },

    enableing() {
      this.timer = window.setInterval(this.frame, 30);
      const anchor_creator_ids = [];
      const count = this.todo_list.length;

      this.todo_list.forEach((item) => {
        anchor_creator_ids.push(item.id);
      });

      this.$ajax(`/creator/update-creator-status`, {
        method: 'post',
        data: {
          status: 10,
          anchor_creator_ids: anchor_creator_ids,
        },
      }).then((res) => {
        window.clearInterval(this.timer);
        this.progress = 100;
        this.$store.commit('check_limit', this);
        this.$store.state.import_creator_first_name = count === 1 && this.todo_list[0] ? this.todo_list[0].first_name : '';

        if (this.data.length === 0 || this.$store.state.creator_max_count === this.current_creator_count) {
          setTimeout(() => {
            this.$router.replace('/creator/list');
            this.$store.state.is_show_share = true;
            this.$store.state.import_count = this.pick_data; //(this.$store.state.import_count + count);
            // console.log(this.$store.state.import_count, count)
          }, 500);
        } else {
          this.total_row_count = this.data.length + this.exist_creators.length;
          this.new_creator_count = this.data.length;
          this.is_show_enabling = false;
          this.$store.state.import_count = count;
          this.current_creator_count = this.getNonErrorSelectedCount();
          setTimeout(() => {
            this.$notify(
              `<svg><use xlink:href="#yes--sprite"></use></svg> ${count} Creator${count === 1 ? '' : 's'} imported.`
            );
          }, 500);
        }
      });
    },

    saveEdit(vals) {
      // console.log(vals);
      (this.edit_row.states = vals.states),
        (this.edit_row.first_name = vals.first_name),
        (this.edit_row.last_name = vals.last_name),
        (this.edit_row.tiktok_handle = vals.tiktok_handle ? vals.tiktok_handle : ''),
        (this.edit_row.instagram_handle = vals.instagram_handle ? vals.instagram_handle : ''),
        (this.edit_row.youtube_handle = vals.youtube_handle ? vals.youtube_handle : ''),
        (this.edit_row.email = vals.email),
        (this.edit_row.platform_type = vals.platform_type || this.edit_row.platform_type),
        (this.edit_row.merchant_account_tags = vals.merchant_account_tags.map((e) => {
          return {
            ...e,
            text: e.tag,
          };
        }));
      this.edit_row.disable = this.handleDis(vals);
      this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> Saved successfully.');

      this.current_creator_count = this.getNonErrorSelectedCount();
      this.table_key += 1;
    },

    scroll() {
      //if (this.$refs.heading) this.top = `--top: ${this.$refs.heading.offsetHeight}px`;
      // console.log(this.$refs.heading.offsetHeight)
    },

    handleDis(row) {
      return (
        row.status === -4 ||
        row.first_name === '' ||
        row.last_name === '' ||
        (this.$store.state.projectName === 'cj' ? row.email === '' : (row.tiktok_handle === '' && row.instagram_handle === '' && row.email === '')) ||
        (row.tiktok_handle !== '' && !/(^$)|^@?[a-zA-Z0-9_.]+$/.test(row.tiktok_handle)) ||
        (row.instagram_handle !== '' && !/(^$)|^[aA-zZ0-9_.]+$/.test(row.instagram_handle)) ||
        (row.email && !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/.test(row.email)) ||
        this.checkSame(row.email, 'email', row.id) ||
        this.checkSame(row.tiktok_handle, 'tiktok_handle', row.id) ||
        this.checkSame(row.instagram_handle, 'instagram_handle', row.id)
      );
    },

    getNonErrorSelectedCount() {
      return this.data.filter((o) => o.is_selected && !this.handleDis(o)).length;
    },

    checkSame(val, field, id) {
      return val && this.data.some((item) => item[field] === val && item.id !== id);
    },

    async handleData() {
      this.is_loading = true;
      let select_count = this.$store.state.current_creator_count;
      //handle tag--------------------------------------------
      let tagData = await getTags(this);
      if (tagData.data) {
        this.all_cre_tags = [];
        tagData.data.forEach((e) => {
          this.all_cre_tags.push(e);
        });
        this.programs_for_cre = tagData.orgData;
      }

      //-------------------------------------------------------------
      this.data = this.data.map((row) => {
        const isError = this.handleDis(row);
        //處理每個人的tag選擇
        handleCreTag(row, this.programs_for_cre);
        let can_sec = false;
        if (!isError && select_count < this.$store.state.creator_max_count) {
          can_sec = true;
          select_count++;
        }
        return {
          ...row,
          is_selected: can_sec,
          platform_type: this.is_link_only ? 'linkonly' : (row.platform_type || 'storefront'),
        };
      });
      //if (this.current_creator_count >= this.$store.state.creator_max_count ) {
      this.data = this.removeDuplicates(this.data);

      this.current_creator_count = this.getNonErrorSelectedCount();
      this.is_loading = false;
    },

    removeDuplicates(data) {
      const uniqueData = [];
      const dataMap = new Map();
      this.new_creator_count = 0;
      this.total_row_count = 0;
      data.forEach((row) => {
        const key = `${row.first_name}-${row.last_name}-${row.tiktok_handle}-${row.instagram_handle}`;
        if (!dataMap.has(key)) {
          dataMap.set(key, true);
          this.new_creator_count++;
          this.total_row_count++;
          uniqueData.push(row);
        }
      });

      return uniqueData;
    },

    //打開個人的tag list選單
    openCreTag(index, name) {
      this.data.forEach((e, k) => {
        if (k === index && name === 'name') {
          e.open = !e.open;
          e.last_tag_open = false;
          e.last_tag_all_open = false;
        } else if (k === index && name === 'tag') {
          e.last_tag_open = !e.last_tag_open;
          e.open = false;
          e.last_tag_all_open = false;
        } else if (k === index && name === 'tag_all') {
          e.last_tag_all_open = !e.last_tag_all_open;
          e.open = false;
        } else {
          e.open = false;
          e.last_tag_open = false;
          e.last_tag_all_open = false;
        }
      });

      this.open_cre_tag_drop = !this.data.every((e) => !e.open && !e.last_tag_open) && this.data.length < 10;
    },

    styleTagLong(row, v, k) {
      if (row.merchant_account_tags.length === 1) {
        return `tag-item-box-only-one`;
      } else if (row.merchant_account_tags.length > 1) {
        if (row.merchant_account_tags[0].tag?.length < 8 && k === 1) {
          return `tag-item-box-pick-long`;
        } else if (row.merchant_account_tags[1].tag?.length < 8 && k === 0) {
          return `tag-item-box-pick-long`;
        } else if (row.merchant_account_tags.length === 2) {
          return 'tag-item-box-longer';
        } else {
          return '';
        }
      } else {
        return '';
      }
    },

    //這邊會處理單人的tag刪減增加,API處理會在元件裡面做完(除了有spec_text的要另外CALL)
    selectTag(item, spec_text) {
      selectTag(item, spec_text, this);
    },

    handleSelectTag(item, spec_text) {
      this.handle_remove_tag_value.row = item.row;
      this.handle_remove_tag_value.tag = item.tag;
      this.tag_remove_modal = true;
    },
  },

  mounted() {
    this.EventBus.off('update-add-creator-table');
    if (!this.permission_creator.addCreators.permission) {
      this.$router.push('/creator/list');
      return;
    }

    // if (!window.localStorage.getItem('has_entered_get_started')) {
    //   this.is_show_get_started = true;
    // }
    
    // Initialize columns based on project
    if (this.$ProjectName === 'sephora') {
      this.columns = [
        { label: 'Creator' },
        { label: 'Email' },
        { label: 'TikTok' },
        { label: 'Instagram' },
        { label: 'Account Type' },
        { label: 'Tags' },
        { label: 'Options' },
      ];
      this.enable_columns = [
        { label: 'Creator Name' },
        { label: 'Email' },
        { label: 'TikTok' },
        { label: 'Instagram' },
        { label: 'Account Type' },
        { label: `Enable <svg class="ico"><use xlink:href="#question--sprite"></use></svg>` },
      ];
    } else {
      this.columns = [
        { label: 'Creator' },
        { label: 'Email' },
        { label: 'TikTok' },
        { label: 'Instagram' },
        { label: 'Motom Status' },
        { label: 'Account Type' },
        { label: 'Tags' },
        { label: 'Options' },
      ];
      this.enable_columns = [
        { label: 'Creator Name' },
        { label: 'Email' },
        { label: 'TikTok' },
        { label: 'Instagram' },
        { label: 'Motom Status' },
        { label: 'Account Type' },
        { label: `Enable <svg class="ico"><use xlink:href="#question--sprite"></use></svg>` },
      ];
    }

    this.$store.commit('check_limit', this);
    if (this.$store.state.upload_data) {
      this.$store.state.import_count = 0;
      this.$store.state.import_creator_first_name = '';
      this.updateCreator(this.$store.state.upload_data);
      this.is_show_list = true;
      this.EventBus.emit('update-import-stage', 1);
      this.$store.state.upload_data = false;
    }

    this.EventBus.on('update-add-creator-table', (obj) => {
      if (this.data.length > 1) {
        this.is_loading = true;

        if (obj.type === 'add') {
          this.programs_for_cre.push(obj.tag);
        } else if (obj.type === 'remove') {
          this.programs_for_cre = this.programs_for_cre.filter((e) => e.id !== obj.tag.id);
        } else if (obj.type === 'update') {
          this.programs_for_cre.forEach((e, index) => {
            if (e.id === obj.tag.id) {
              this.programs_for_cre[index] = obj.tag;
            }
          });
        }

        this.data.forEach((e) => {
          handleCreTag(e, this.programs_for_cre);
        });
        this.is_loading = false;
      }
    });

    // document.addEventListener('click', (e) => {
    //     if (e.target.classList.contains('notify-link')) {
    //         this.$router.push('/help');
    //     }
    // });
  },
};
</script>

<style lang="scss">
.creator-content {
  .add-partner-container {
    padding: 16px;
  }
  .alert-modal{
    .el-dialog__header{
      display: none;
    }
  }
  .inner {
    height: 100%;
    display: flex;
    padding: 24px 16px;

    &.no-padding {
      padding: 24px 0 0 24px;

      .add-heading {
        height: 64px;

        h2 {
          font: var(--font-demi-36);
          color: black;
        }
      }

      .add-partner {
        background-color: var(--PB-40);
        border-radius: 16px 0 0 0;
        padding: 16px;
        min-height: calc(100vh - 104px);
      }
    }
  }

  .right {
    padding: 0 32px;
    flex: 1;
  }

  .heading {
    min-height: 32px;
    padding: 0 0 16px;
    border-bottom: 1px solid var(--black-20);
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: white;

    .top {
      position: relative;

      h2 {
        font: var(--font-demi-24);
        color: var(--black-90);
        flex: 1;
      }

      p {
        margin-top: 4px;
        font-size: 14px;
        color: var(--black-90);
        line-height: 1.5;
      }

      .btns {
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -15px;
        height: 30px;
      }

      .close {
        height: 30px;
        width: 30px;
        position: relative;
        border: 1px solid var(--black-60);
        display: block;
        box-sizing: content-box;
        border-radius: 50%;
        cursor: pointer;
        margin-left: 8px;

        svg {
          height: 10px;
          width: 10px;
          position: relative;
          left: 50%;
          top: 50%;
          margin: -5px 0 0 -5px;
          fill: var(--black-90);
        }
      }

      .close:hover,
      .ui-button:hover {
        border-color: var(--dark-blue);
        color: var(--dark-blue);

        svg {
          fill: var(--dark-blue);
        }
      }
        .heading {
            min-height: 32px;
            padding: 0 0 16px;
            border-bottom: 1px solid var(--black-20);
            position: sticky;
            top: 0;
            z-index: 10;
            background-color: white;

            .top {
                display: flex;
                align-items: center;

                h2 {
                    font: var(--font-demi-24);
                    color: var(--black-90);
                    flex: 1;
                }

                .btns {
                    display: flex;
                    align-items: center;
                }
                
                .close {
                    height: 30px;
                    width: 30px;
                    position: relative;
                    border: 1px solid var(--black-60);
                    display: block;
                    box-sizing: content-box;
                    border-radius: 50%;
                    cursor: pointer;
                    margin-left: 8px;

                    svg {
                        height: 10px;
                        width: 10px;
                        position: relative;
                        left: 50%;
                        top: 50%;
                        margin: -5px 0 0 -5px;
                        fill: var(--black-90);
                    }
                }

                .close:hover,
                .ui-button:hover {
                    border-color: var(--dark-blue);
                    color: var(--dark-blue);


                    svg {
                        fill: var(--dark-blue);
                    }
                }
            }

            .text-wrap {
                display: flex;
                align-items: center;
                margin-top: 16px;
            }

            .text + .ui-usage-wrap {
                margin-left: 12px;
            }

            .text {
                font-size: 12px;
                color: var(--black-90);
            }

            .warning {
                margin-left: 12px;
                font-size: 12px;
                display: flex;
                align-items: center;

                a {
                    text-decoration: underline;

                    &:hover {
                        text-decoration: none;
                    }
                }
            }

            .error-msg {
                color: var(--alert);
            }
        }

        .selected-info {
            padding: 16px 0 0;
            margin-top: 16px;
            border-top: 1px solid var(--black-20);
            display: flex;
            align-items: center;

            strong {
                flex: 1;
                font-weight: 600;
                color: var(--black-75);
            }

            .ui-button.color-no-color {
                margin-right: 10px;
            }


            .btns {
                display: flex;
                align-items: center;

                .ui-button {
                    margin-left: 10px;
                }

                .ui-button.color-no-color {
                    padding: 0 10px;
                }
                
                .add-more-btn {
                    display: flex;
                    align-items: center;

                    svg {
                        height: 11px;
                        width: 14px;
                        margin-right: 5px;
                    }
                }

                &.disabled {
                    
                    .ui-button.color-no-color {
                        color: var(--black-20);
                        pointer-events: none;
                    }
                    
                    .ui-button.type-bg.color-dark-blue {
                        background-color: var(--black-20);
                        pointer-events: none;
                    }
                }
            }
        }
        
        .upload-box {
            padding: 40px 64px;
            min-height: 100%;
            background-color: var(--bg-02);

            .title {
                font: var(--font-demi-20);
                color: var(--black-90);
                display: flex;
                align-items: center;

                // &::before {
                //     content: attr(data-number) '.';
                //     display: block;
                //     width: 24px;
                // }

                & + .ui-button {
                    margin: 16px 0 0 24px;
                }
            }
        }

        .progress-rate {
            display: flex;
            align-items: center;
            margin: 8px 0;
            position: relative;
        
            .bar {
                flex: 1;
                padding: 6px 16px;

                .bg {
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 0%;
                    transition: .3s width ease;
                    pointer-events: none;
                    background-color: var(--dark-blue);
                }

                & * {
                    position: relative;
                    z-index: 3;
                }
            }

            .btns {
                padding: 12px;
                position: relative;
                z-index: 3;

                .ui-button {
                    margin-left: 12px;
                }
            }
        }
        
        .data-wrap {
            margin: 0 0 16px 0;

            .disabled .row-item {
                opacity: .5;
                pointer-events: none;

                &.selected {
                    opacity: 1;
                    pointer-events: auto;
                }
            }


            .ui-table {
                .thead {
                    

                    th:last-child span {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;

                        .ico {
                            height: 10px;
                            width: 10px;
                            display: block;
                            margin-left: 5px;
                            fill: var(--black-50);
                        }
                    }
                }

                .btns {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    width: 100%;
                }
                
                .svg-icon--waiting {
                    height: 14px;
                    width: 10px;
                    display: block;
                    float: right;
                    margin: 0 10px;
                    fill: var(--black-90);
                }

                .svg-icon--yes {
                    height: 14px;
                    width: 14px;
                    display: block;
                    float: right;
                    margin: 0 10px;
                    fill: var(--green);
                }

                td.is-disabled {
                    pointer-events: none;
                }

            }
        }

        td.email-td{
            max-width: 120px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        td.tags-list-box-td{
            position:relative;
        }

        .tags-list-box{
            display:flex;
            align-items: center;
            padding:4px;
            gap:6px;
            transition: .3s;
            max-width: 150px;
            min-width: 150px;

            .my-badges-iden{
                display:flex;
                align-items: center;
                border-radius: 6px;
                cursor: pointer;

                svg{
                    width: 8px;
                    height: 8px;
                }

                span{
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    max-width: 76px;
                }

                &.tag-item-box-only-one span{
                    max-width: 130px;
                }

                &.tag-item-box-longer span{
                    max-width: 100px;
                }

                &.tag-item-box-pick-long span{
                    max-width: 130px;
                }

                &:first-child{
                    span{
                        max-width: 150px;
                    }
                }
            }
            

            .svg-icon{
                margin-left: 6px;
                width: 0px;
                transition: opacity 0.3s ease;

                &.ths-show{
                    width: 8px;
                }
            }

            &.edit-tags-list-box{
                border:solid 1px var(--neutral);
                border-radius:6px;
                
            }
            
        }

        .add-tag-btn{
            padding: 4px;
            border:solid 1px var(--neutral);
            border-radius:6px;
            height: 24px;

            .svg-icon{
                margin: unset;
                width: 14px;
                height: 14px;
            }
        }

    }

    .text-wrap {
      display: flex;
      align-items: center;
      margin-top: 16px;
    }

    .text + .ui-usage-wrap {
      margin-left: 12px;
    }

    .text {
      font-size: 12px;
      color: var(--black-90);
    }

    .warning {
      margin-left: 12px;
      font-size: 12px;
      display: flex;
      align-items: center;

      a {
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }
    }

    .error-msg {
      color: var(--alert);
    }
  }

  .selected-info {
    padding: 16px 0 0;
    margin-top: 16px;
    border-top: 1px solid var(--black-20);
    display: flex;
    align-items: center;

    strong {
      flex: 1;
      font-weight: 600;
      color: var(--black-75);
    }

    .ui-button.color-no-color {
      margin-right: 10px;
    }

    .btns {
      display: flex;
      align-items: center;

      .ui-button {
        margin-left: 10px;
      }

      .ui-button.color-no-color {
        padding: 0 10px;
      }

      .add-more-btn {
        display: flex;
        align-items: center;

        svg {
          height: 11px;
          width: 14px;
          margin-right: 5px;
        }
      }

      &.disabled {
        .ui-button.color-no-color {
          color: var(--black-20);
          pointer-events: none;
        }

        .ui-button.type-bg.color-dark-blue {
          background-color: var(--black-20);
          pointer-events: none;
        }
      }
    }
  }

  // .upload-box {
  //   padding: 40px 64px;
  //   min-height: 100%;
  //   background-color: var(--bg-02);

  //   .title {
  //     font: var(--font-demi-20);
  //     color: var(--black-90);
  //     display: flex;
  //     align-items: center;

  //     // &::before {
  //     //     content: attr(data-number) '.';
  //     //     display: block;
  //     //     width: 24px;
  //     // }

  //     & + .ui-button {
  //       margin: 16px 0 0 24px;
  //     }
  //   }
  // }

  .progress-rate {
    display: flex;
    align-items: center;
    margin: 8px 0;
    position: relative;

    .bar {
      flex: 1;
      padding: 6px 16px;

      .bg {
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        width: 0%;
        transition: 0.3s width ease;
        pointer-events: none;
        background-color: var(--dark-blue);
      }

      & * {
        position: relative;
        z-index: 3;
      }
    }

    .btns {
      padding: 12px;
      position: relative;
      z-index: 3;

      .ui-button {
        margin-left: 12px;
      }
    }
  }

  .data-wrap {
    margin: 0 0 16px 0;

    .disabled .row-item {
      opacity: 0.5;
      pointer-events: none;

      &.selected {
        opacity: 1;
        pointer-events: auto;
      }
    }

    .ui-table {
      .thead {
        th:last-child span {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .ico {
            height: 10px;
            width: 10px;
            display: block;
            margin-left: 5px;
            fill: var(--black-50);
          }
        }
      }

      .btns {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
      }

      .svg-icon--waiting {
        height: 14px;
        width: 10px;
        display: block;
        float: right;
        margin: 0 10px;
        fill: var(--black-90);
      }

      .svg-icon--yes {
        height: 14px;
        width: 14px;
        display: block;
        float: right;
        margin: 0 10px;
        fill: var(--green);
      }

      td.is-disabled {
        pointer-events: none;
      }
    }
  }

  td.email-td {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  td.tags-list-box-td {
    position: relative;
  }

  .tags-list-box {
    display: flex;
    align-items: center;
    padding: 4px;
    gap: 6px;
    transition: 0.3s;
    max-width: 150px;
    min-width: 150px;

    .my-badges-iden {
      display: flex;
      align-items: center;
      border-radius: 6px;
      cursor: pointer;

      svg {
        width: 8px;
        height: 8px;
      }

      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 76px;
      }

      &.tag-item-box-only-one span {
        max-width: 130px;
      }

      &.tag-item-box-longer span {
        max-width: 100px;
      }

      &.tag-item-box-pick-long span {
        max-width: 130px;
      }

      &:first-child {
        span {
          max-width: 150px;
        }
      }
    }

    .svg-icon {
      margin-left: 6px;
      width: 0px;
      transition: opacity 0.3s ease;

      &.ths-show {
        width: 8px;
      }
    }

    &.edit-tags-list-box {
      border: solid 1px var(--neutral);
      border-radius: 6px;
    }
  }

  .add-tag-btn {
    padding: 4px;
    border: solid 1px var(--neutral);
    border-radius: 6px;
    height: 24px;

    .svg-icon {
      margin: unset;
      width: 14px;
      height: 14px;
    }
  }
}

.alert-modal,
.add-creator-modal {
  .el-dialog__body {
    padding: 0;
  }
}

.account-type-td {
  .account-type-inline-select {
    width: 150px;

    .el-select__wrapper {
      border: none;
      padding: 0;
      background: transparent;
      cursor: pointer;
      box-shadow: none;

      &:hover {
        box-shadow: none !important;
      }

      .el-select__selected-item {
        font: var(--font-med-12);
        color: var(--black-90);
        cursor: pointer;
      }

      .el-input__suffix {
        .el-icon {
          color: var(--black-90);
          font-size: 12px;
        }
      }
    }
  }
}
/*
.get-started-modal {

  .ui-modal--container {
    width: 460px;
  }

  h2 {
    font: var(--font-med-24);
    color: var(--black-90);
    margin-bottom: 24px;
  }

  p {
    font-size: 14px;
    color: var(--black-90);
    margin-bottom: 32px;
  }

  .ui-button {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .box {
    padding: 56px;
  }
}
*/

</style>
